export const WEAPON_MODIFICATIONS = {
    "1": {
        name: "FINELY BALANCED",
        flavor: "Perfectly weighted for the weapon's owner, this    weapons feels to be on extension of their own limbs.",
        description: "  Improve this weapon's Ballistic Skill or Weapon Skill    characteristic by 1."
    },
    "2": {
        name: "BRUTAL",
        flavor: "Enhanced with hyper-dense metol/oids or empowered .:;a    by advanced energies, this weopon con be wielded with ~    meteoric force.",
        description: "Add 1 to this weapon's Strength characteristic."
    },
    "3": {
        name: "ARMOUR PIERCING",
        flavor: "Honed to o razor-edged sharpness or invested with    crackling energy fields, this weopon con crock the    heaviest enemy bottle plate.",
        description: "Improve this weapon's Armour Penetration    characteristic by 1."
    },
    "4": {
        name: "MASTER-WORKED",
        flavor: "Forged by moster-smiths ond hand-worked over    generations by skilled artificers, this weapon's deadly    killing power matches its mortiol elegance.",
        description: "Add 1 to this weapon's Damage characteristic."
    },
    "5": {
        name: "HEIRLOOM",
        flavor: "Handed to worthy scions or claimed by ruthless victors,    the greatest weapons ore valued for their quality.",
        description: "Add 1 to this weapon's Attacks characteristic."
    },
    "6": {
        name: "PRECISE",
        flavor: "Whether fitted with superior scopes or crafted by master    duellists, this weapon has been modified with the sole sm    purpose of executing enemy heroes and commanders.",
        description: " Each time a Critical Wound is scored for an attack made    with this weapon, that attack has the Precision ability    (Core Rules)."
    },
}